import React from 'react';
import moment from 'moment';
import connect from 'Shared/connect';
import { toggleDeliveryDays, hideDeliveryDays } from '../../../../action-creators';
import { translate } from 'Shared/translate';
import DeliveryDates from '../../../../../../Shared/DeliveryDates';
import { SMALL } from 'Shared/breakpoints';
import * as styles from './DeliveryDatesButton.scss';
import * as toprowstyles from '../../TopBar/TopBar.scss';
import classnames from 'classnames';
import MyMenigoIcon from '../../../../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon';
import Overlay from 'Shared/Overlay';
import Icon from 'Shared/Icon';
class DeliveryDatesButton extends React.Component {
    constructor(props) {
        super(props);
    }
    getFormatForNewStoptime() {
        const selectedDateString = `${this.props.headerViewModel.selectedDelivery.stopDate} ${this.props.headerViewModel.selectedDelivery.stopTime}`;
        const selectedDate = new Date(selectedDateString);
        const currentDate = moment().toDate();
        const timeDiff = Math.abs(selectedDate.getTime() - currentDate.getTime());
        if (timeDiff < 3600000) {
            // Less than 1 hour
            const diffMinutes = Math.ceil(timeDiff / (1000 * 60));
            return diffMinutes + ' ' + translate('/DeliveryDate/MinutesLeft');
        }
        else if (timeDiff < 86400000) {
            // Less than 24 hours
            const diffHours = Math.ceil(timeDiff / (1000 * 3600));
            return diffHours + ' ' + translate('/DeliveryDate/HoursLeft');
        }
        else if (timeDiff < 172800000) {
            // Less than 48 hours
            const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            return diffDays + ' ' + translate('/DeliveryDate/DayLeftOfStopTime');
        }
        else {
            const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            return diffDays + ' ' + translate('/DeliveryDate/DaysLeftOfStopTime');
        }
    }
    getStopText() {
        return (this.props.headerViewModel.selectedDelivery &&
            `${this.props.headerViewModel.selectedDelivery.stopDate}  ${this.props.headerViewModel.selectedDelivery.stopTime}`);
    }
    getDepartureText() {
        return !!this.props.headerViewModel.selectedDelivery
            ? `${translate('/DeliveryDate/DeliveryDay')}: ${this.props.headerViewModel.selectedDelivery.departureDateAsString}`
            : '';
    }
    render() {
        const isMobile = this.props.currentBreakpoint < SMALL;
        if (this.props.currentPage.componentName.indexOf('CheckoutPage') >= 0) {
            return null;
        }
        if (isMobile)
            return (React.createElement("a", { className: styles.deliveryButton, onClick: () => this.props.toggleDeliveryDays() },
                React.createElement(MyMenigoIcon, { name: 'headerDeliveries' })));
        return (React.createElement(Overlay, { onClose: () => this.props.hideDeliveryDays(), enabled: this.props.deliveryDaysIsVisible, className: classnames(styles.base, this.props.deliveryDaysIsVisible && styles.open) },
            React.createElement("div", { className: classnames(styles.deliveryDateWrapper, this.props.deliveryDaysIsVisible && styles.open, !this.props.headerViewModel.selectedDelivery && styles.error, 'ui-test-delivery-date-info') },
                this.props.headerViewModel.selectedDelivery ? (React.createElement("a", { className: classnames(styles.deliveryButton, this.props.deliveryDaysIsVisible && styles.open), onClick: () => this.props.toggleDeliveryDays() },
                    React.createElement(MyMenigoIcon, { name: 'headerDeliveries' }),
                    React.createElement("div", { className: toprowstyles.TopBarRow },
                        React.createElement("div", { key: "departureText" },
                            React.createElement("strong", null, this.getDepartureText())),
                        React.createElement("div", { key: "deliveryText" },
                            this.getFormatForNewStoptime(),
                            ' ',
                            !this.props.deliveryDaysIsVisible ? (React.createElement(Icon, { className: styles.dropdownIcon, name: "dropdown-arrowdown" })) : (React.createElement(Icon, { className: styles.dropdownIcon, name: "dropdown-arrowup" })))))) : (React.createElement("a", { className: classnames(styles.deliveryButton, this.props.deliveryDaysIsVisible && styles.open) },
                    React.createElement(MyMenigoIcon, { name: "headerDeliveries" }),
                    React.createElement("div", { className: styles.validationError }, this.getDepartureText()))),
                this.props.deliveryDaysIsVisible && (React.createElement("div", null,
                    React.createElement(DeliveryDates, { hasWrapper: true, hideHeader: true, className: styles.deliveryDatesWrapper, deliveryDays: this.props.headerViewModel.deliveryDates, selectedDelivery: this.props.headerViewModel.selectedDelivery }))))));
    }
}
export default connect((state) => ({
    deliveryDaysIsVisible: state.deliveryDaysVisibility.visible,
    headerViewModel: state.appShellData.header,
    currentBreakpoint: state.currentBreakpoint,
    currentPage: state.currentPage,
}), (dispatch) => ({
    toggleDeliveryDays() {
        return dispatch(toggleDeliveryDays());
    },
    hideDeliveryDays() {
        return dispatch(hideDeliveryDays());
    },
}))(DeliveryDatesButton);
